import { Printer } from '@phosphor-icons/react'
import { useFormat, useI18n } from '@/i18n'
import type { PackLot } from '@/offline/sitePack'
import { BilingualLabel, Button, Card, CardBody, CardHeader } from '@/ui'

/** What the coder prints on every pouch — key it in exactly as shown (F7.2). */
export function CoderCard({ lot }: { lot: PackLot }) {
  const { t } = useI18n()
  const fmt = useFormat()
  return (
    <Card className="border-ink">
      <CardHeader
        eyebrow={<BilingualLabel k="pack.coder.title" />}
        actions={
          <Button size="sm" variant="ghost" leadingIcon={<Printer aria-hidden="true" />} onClick={() => window.print()}>
            {t('pack.coder.print')}
          </Button>
        }
      />
      <CardBody className="flex flex-col gap-2 pt-0">
        <div className="break-all font-mono text-[26px] font-bold leading-tight tracking-wide">{lot.code}</div>
        <div className="grid grid-cols-2 gap-2 text-[14px]">
          <div>
            <div className="text-[12px] text-muted">{t('pack.coder.packDate')}</div>
            <div className="font-mono font-bold">{fmt.date(lot.pack_date)}</div>
          </div>
          <div>
            <div className="text-[12px] text-muted">{t('pack.coder.bestBefore')}</div>
            <div className="font-mono font-bold">{fmt.date(lot.best_before)}</div>
          </div>
        </div>
        <div>
          <div className="text-[12px] text-muted">{t('pack.coder.link')}</div>
          <div className="break-all font-mono text-[14px]">{lot.qr_url}</div>
        </div>
        <p className="text-[12px] text-muted">{t('pack.coder.hint')}</p>
      </CardBody>
    </Card>
  )
}
